module.exports = "img/icon_context_fave.c05e648.svg";